var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10208",
    "data-name": "Group 10208",
    transform: "translate(16619 11038)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-16619 -11038)",
    fill: "#344b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M7.5,0,6.136,1.364,11.3,6.526H0V8.474H11.3L6.136,13.636,7.5,15,15,7.5Z",
    transform: "translate(-16606 -11010) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6764",
    "data-name": "Path 6764",
    d: "M-16732.9-9308.162Z",
    transform: "translate(150 -1718)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/TopArrow.eab502fa90b38c25acd971c512eb6187.svg";
export { ForwardRef as ReactComponent };